import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';

export default class WorkflowTestApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  // public async getWorkflowsTest(searchBy: string): Promise<any> {
  //   let queryParam = '';
  //   if(searchBy) {
  //     queryParam = '?name=' + searchBy;
  //   }
  //   return super.get(api.workflow_dashboard + queryParam );
  // }
  public async getWorkFlowTestScenarios(data: any): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(api.get_workflow_test_scenarios + '?' + querystring);
  }

  public async newWorkflowTestScenario(formData: FormData): Promise<any> {
    return super.post(api.create_workflowtest_scenario, formData);
  }

  public async runWorkflowTest(id: any): Promise<any> {
    return super.post(api.run_wf_test_by_id + id, {});
  }

  public async editWorkflowTestScenario(
    id: string,
    formData: FormData,
  ): Promise<any> {
    return super.put(`${api.edit_workflowtest_scenario}${id}`, formData);
  }

  public async deleteWorkflowTestScenario(id: string): Promise<any> {
    return super.post(`${api.delete_workflowtest_scenario}${id}`, {});
  }

  public async toggleActivateTest(workflow_id: string): Promise<any> {
    return super.post(`${api.toggle_activate_test}${workflow_id}`, {});
  }

  public async runAllTests(onProgress: (data: any) => void): Promise<void> {
    const token = await this.getToken();
    const orgId = this.getOrgId();

    const headers: Record<string, string> = {
      Authorization: token,
      Accept: 'text/event-stream',
    };

    if (orgId) {
      headers['X-ORG-ID'] = orgId;
    }

    return new Promise((resolve, reject) => {
      fetch(api.run_all_tests, {
        method: 'POST',
        headers,
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const reader = response.body?.getReader();
          if (!reader) {
            throw new Error('No response body');
          }

          const decoder = new TextDecoder();
          let buffer = '';

          while (true) {
            const { done, value } = await reader.read();

            if (done) {
              resolve();
              break;
            }

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split('\n');
            buffer = lines.pop() || '';

            for (const line of lines) {
              if (line.startsWith('data: ')) {
                try {
                  const data = JSON.parse(line.slice(6));
                  onProgress(data);

                  if (data.type === 'complete' || data.type === 'error') {
                    reader.cancel();
                    resolve();
                    return;
                  }
                } catch (err) {
                  console.error('Error parsing SSE data:', err);
                }
              }
            }
          }
        })
        .catch((error) => {
          console.error('SSE connection error:', error);
          reject(error);
        });
    });
  }
}
